import React, { useState, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  Modal,
  ModalHeader,
  ModalBody,
  Container,
  Button
} from "reactstrap";
import routes from "routes.js";
//import { msalInstance, loginRequest } from "authConfig";
import { msalInstance, loginRequest } from "../../authConfig.js";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useAuth } from "context/authContext.js";
import { useAccessToken } from "context/tokenConfig.js";
import { siteurl } from "../../authConfig.js";
import ClientSelection from "components/SelectClient.js";
import { useClient } from "context/clientContext.js";

function Header(props) {
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [color, setColor] = useState("transparent");
  const { hasLoggedIn, login, logout } = useAuth();
  const sidebarToggle = useRef();
  const location = useLocation();
  const { instance, accounts } = useMsal();
  const { accessToken } = useAccessToken();
  const { client, selectedClientName } = useClient()
  const [isClientModalOpen, setIsClientModalOpen] = useState(false);

  const toggleClientModal = () => setIsClientModalOpen(!isClientModalOpen);


  (async () => {
    try {
      await msalInstance.initialize();
    } catch (error) {
      console.error("Error initializing MSAL instance:", error);
    }
  })();


  const handleLogin = () => {
    msalInstance
      .loginPopup(loginRequest)
      .then(async (response) => {
        console.log("Login successful:", response);
        await login();
        window.location.reload();
      })
      .catch(error => {
        console.error("Login error:", error);
      });
  };

  const signOut = () => {
    const logoutRequest = {
      account: instance.getAccountByHomeId(accounts[0]?.homeAccountId),
      postLogoutRedirectUri: `${siteurl}`,
    };
    localStorage.clear();
    instance.logoutRedirect(logoutRequest);
  };

  const toggle = () => {
    if (isOpen) {
      setColor("transparent");
    } else {
      setColor("dark");
    }
    setIsOpen(!isOpen);
  };
  const dropdownToggle = (e) => {
    setDropdownOpen(!dropdownOpen);
  };
  const getBrand = () => {
    let brandName = "Default Brand";
    routes.map((prop, key) => {
      if (window.location.href.indexOf(prop.layout + prop.path) !== -1) {
        brandName = prop.name;
      }
      return null;
    });
    return brandName;
  };
  const openSidebar = () => {
    document.documentElement.classList.toggle("nav-open");
    sidebarToggle.current.classList.toggle("toggled");
  };
  // function that adds color dark/transparent to the navbar on resize (this is for the collapse)
  const updateColor = () => {
    if (window.innerWidth < 993 && isOpen) {
      setColor("dark");
    } else {
      setColor("transparent");
    }
  };
  React.useEffect(() => {
    window.addEventListener("resize", updateColor.bind(this));
  });
  React.useEffect(() => {
    if (
      window.innerWidth < 993 &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
      sidebarToggle.current.classList.toggle("toggled");
    }
  }, [location]);
  return (
    // add or remove classes depending if we are on full-screen-maps page or not
    <Navbar
      color={
        location.pathname.indexOf("full-screen-maps") !== -1 ? "dark" : color
      }
      expand="lg"
      className={
        location.pathname.indexOf("full-screen-maps") !== -1
          ? "navbar-absolute fixed-top"
          : "navbar-absolute fixed-top " +
          (color === "transparent" ? "navbar-transparent " : "")
      }
    >
      <Container fluid>
        <div className="navbar-wrapper">
          <div className="navbar-toggle">
            <button
              type="button"
              ref={sidebarToggle}
              className="navbar-toggler"
              onClick={() => openSidebar()}
            >
              <span className="navbar-toggler-bar bar1" />
              <span className="navbar-toggler-bar bar2" />
              <span className="navbar-toggler-bar bar3" />
            </button>
          </div>
          <NavbarBrand style={{ fontWeight: 700, color: "#201E1F", fontSize: "18px", spacing: "0.1em" }} href="/">{getBrand()}</NavbarBrand>
        </div>
        <NavbarToggler onClick={toggle}>
          <span className="navbar-toggler-bar navbar-kebab" />
          <span className="navbar-toggler-bar navbar-kebab" />
          <span className="navbar-toggler-bar navbar-kebab" />
        </NavbarToggler>
     <Collapse isOpen={isOpen} navbar className="justify-content-end">
  {accessToken !== null ? (
   <Nav
  navbar
  style={{
    display: "flex",
    width: "100%",
    alignItems: "center",
    justifyContent: "flex-end",
  }}
>
  <div
    style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      paddingRight: "20px",
    }}
  >
    {client === 0 && (
      <div style={{ fontSize: "16px" }}>
        Client: <strong>{selectedClientName || "None"}</strong>
      </div>
    )}
  </div>

  <div
    style={{
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
      paddingRight: "20px",
    }}
  >
    {client === 0 && (
      <Button
        onClick={toggleClientModal}
        style={{ backgroundColor: "#201E1F" }}
        className="btn-round"
      >
        Select Client
      </Button>
    )}
  </div>

  <div
    style={{
      display: "flex",
      justifyContent: "flex-end",
      alignItems: "center",
    }}
  >
    <Button
      onClick={signOut}
      style={{ backgroundColor: "#fb0000" }}
      className="btn-round"
    >
      Log Out
    </Button>
  </div>
</Nav>

  ) : (
    <Nav navbar>
      <Button
        onClick={handleLogin}
        style={{ backgroundColor: "#fb0000" }}
        block
        className="btn-round"
      >
        Log In
      </Button>
    </Nav>
  )}
</Collapse>


      </Container>

      <Modal isOpen={isClientModalOpen} toggle={toggleClientModal} style={{ marginTop: "100px" }}>
        <ModalHeader toggle={toggleClientModal}>Select a Client</ModalHeader>
        <ModalBody>
          <ClientSelection />

          <div>
            <Button
              onClick={() => setIsClientModalOpen(false)}
              style={{ backgroundColor: "#fb0000" }}
              block
              className="btn-round"
            >
              Done
            </Button>
          </div>
        </ModalBody>
      </Modal>

    </Navbar>

  );
}

export default Header;
